import { render } from "./Popup.vue?vue&type=template&id=46167ea3"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Cadpeople\\arla-afi-3-segments-launch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__